export const zeroDistance = { dist: 0, is_override: false };
